export default class CreateDto {
  public targetPlayerId: number = 0;
}
